import { render, staticRenderFns } from "./financeiro-carga-remuneracao.vue?vue&type=template&id=91c9d870&scoped=true"
import script from "./financeiro-carga-remuneracao.vue?vue&type=script&lang=ts"
export * from "./financeiro-carga-remuneracao.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-carga-remuneracao.vue?vue&type=style&index=0&id=91c9d870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c9d870",
  null
  
)

export default component.exports